import SurfaceExaminedHistory from './SurfaceExaminedHistory';

export default class SurfaceExaminedHistoryChanges {
    adds: Array<SurfaceExaminedHistory>;
    updates: Array<SurfaceExaminedHistory>;
    deleteIds: Array<number>;

    constructor() {
        this.adds = [];
        this.updates = [];
        this.deleteIds = [];
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/SurfaceExaminedHistoryChanges.ts